<ng-container *ngIf="showFlex">
    <div class="fs">
        <div style="display: flex;align-items: center;cursor: help;" matTooltipPosition="above"
            [matTooltip]="kostenlosStornoT" matTooltipClass="matTooltip" #tooltiph="matTooltip"
            (click)="tooltiph.toggle()">
            <span multilang style="margin-left: .3rem;">{{kostenlosStorno}} {{kostenlosStornobis | date}}</span>
            <mat-icon style="width: unset;font-size: 1rem;height: unset;margin-left: .5rem;">info
            </mat-icon>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="specials?.length > 0">
    <div class="fsspec">
        <ng-container *ngFor="let spec of specials">
            <div style="display: flex;align-items: center;cursor: help;" matTooltipPosition="above"
                [matTooltip]="spec.tooltip" matTooltipClass="matTooltip" #tooltiph="matTooltip"
                (click)="tooltiph.toggle()">
                <span multilang style="margin-left: .3rem;">{{spec.name}}</span>
                <mat-icon style="width: unset;font-size: 1rem;height: unset;margin-left: .5rem;">info
                </mat-icon>
            </div>
        </ng-container>
    </div>
</ng-container>
<ng-container *ngIf="!showFlex&& specials?.length === 0">
    <div style="padding: 0 .5rem;"
        [matTooltip]="hotel?.catalogData?.previewText?.length > 111 ? hotel?.catalogData?.previewText : ''">
        <span multilang style="font-size: .7rem;font-style: italic;">{{hotel?.catalogData?.previewText?.length >
            111 ?
            hotel?.catalogData?.previewText?.slice(0, 111) + ' ...' : hotel?.catalogData?.previewText}}</span>
    </div>
</ng-container>